import React, { useEffect, useRef, useState } from 'react';
import styles from './WorkItem.module.scss';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { setModalWork } from '../../redux/slices/app.slice';

const getPriceFromLabel = (priceFrom, priceRange) => {
  if (priceFrom) {
    return `от ${priceFrom}`;
  }

  if (priceRange) {
    const [fromPart] = priceRange.split('–');
    if (fromPart?.trim()) {
      return `от ${fromPart.trim()}`;
    }
  }

  return '';
};

const WorkItem = ({ item, onClick, animationIndex = 0, isWide = false, hidePrice = false }) => {
  const dispatch = useDispatch();
  const priceFromLabel = getPriceFromLabel(item?.priceFrom, item?.priceRange);
  const isTelegram = item?.category === 'telegram';
  const boxRef = useRef(null);
  const [hasRevealed, setHasRevealed] = useState(false);
  const detailsMarkup = (
    <div className={clsx(styles.details)}>
      Подробнее
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" className={clsx(styles.detailsIcon)}>
        <path fill="currentColor" d="M13.22 6.03a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06l3.97-3.97H4a.75.75 0 0 1 0-1.5h13.19l-3.97-3.97a.75.75 0 0 1 0-1.06" />
      </svg>
    </div>
  );

  useEffect(() => {
    const node = boxRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setHasRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasRevealed(true);
          observer.disconnect();
        }
      },
      {
        threshold: [0, 0.01, 0.05],
        rootMargin: '0px 0px 28% 0px',
      },
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={boxRef}
      className={clsx(styles.box, hasRevealed ? styles.boxVisible : styles.boxHidden, isWide && styles.boxWide, isTelegram && styles.boxTelegram)}
      style={{ '--stagger-delay': `${Math.min(animationIndex, 6) * 35}ms` }}
      onClick={() => {
        onClick();
        dispatch(setModalWork(true));
      }}>
      <div className={clsx(styles.item)}>
        <img src={item?.prev} className={clsx(styles.image)} alt={item?.title || 'Кейс'} />
      </div>
      <div className={clsx(styles.content)}>
        <div className={clsx(styles.name)}>{item?.title}</div>
        {item?.cardText ? <div className={clsx(styles.cardText)}>{item.cardText}</div> : null}
        {item?.serviceType ? <div className={clsx(styles.serviceType)}>{item.serviceType}</div> : null}
        <div className={clsx(styles.metaLine, hidePrice && styles.metaLineNoBorder)}>
          <span className={clsx(styles.metaValue, styles.metaTime)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 16">
              <path fill="#000" d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6" />
              <path fill="#000" d="M10 10.5c-.09 0-.18-.02-.26-.07l-2.5-1.5A.5.5 0 0 1 7 8.5v-4c0-.28.22-.5.5-.5s.5.22.5.5v3.72l2.26 1.35a.502.502 0 0 1-.26.93" />
            </svg>
            {item?.timeline}
          </span>
          {hidePrice ? detailsMarkup : priceFromLabel ? <span className={clsx(styles.metaValue)}>{priceFromLabel}</span> : null}
        </div>
        {!hidePrice ? detailsMarkup : null}
      </div>
    </div>
  );
};

export default WorkItem;
